import _objectSpread from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import Head from "@/components/Head/index.vue";
import { defineComponent, onMounted, reactive, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import 'element-plus/es/components/message/style/index'

import Pagination from "@/components/Pagination/index.vue";
import useCurrentInstance from "@/hooks/useCurrentInstance";
export default defineComponent({
  name: "AnnualBeforeDetail",
  components: {
    Head: Head,
    Pagination: Pagination
  },
  setup: function setup() {
    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var route = useRoute();
    var router = useRouter();
    var state = route.query.state;
    var history = route.query.history; // const name = computed(()=>{
    //   return (state)=>{
    //     if(state!=4){
    //     }else{
    //       return ''
    //     }
    //   }
    // })

    var Data = reactive({
      title: "",
      total: 99,
      list: [],
      options: [{
        val: 0,
        name: "开始评分"
      }, {
        val: 1,
        name: history == "1" ? "未评分" : "开始评分"
      }, {
        val: 2,
        name: "已评分"
      }, {
        val: 3,
        name: "已评分"
      }, {
        val: 4,
        name: "已过期"
      }],
      // 列表请求参数
      listParams: {
        pageIndex: 1,
        pageSize: 10,
        state: ""
      }
    });
    onMounted(function () {
      Data.title = String(route.query.title);
      getDetail();
    });

    var getDetail = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                Data.listParams.state = state; // if()

                _context.next = 3;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getEvaluationSecretaryUserPage"](_objectSpread({
                  listId: route.query.listId
                }, Data.listParams));

              case 3:
                res = _context.sent;
                Data.list = res.data;
                Data.total = res.total;

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getDetail() {
        return _ref.apply(this, arguments);
      };
    }(); // 监听pager分页改变


    watch(function () {
      return [Data.listParams.pageIndex];
    }, function () {
      getDetail();
    });

    var changPage = function changPage(item) {
      console.log(item);
      Data.listParams.pageIndex = item;
    };

    var itemClick = function itemClick(item) {
      console.log("item: ", item);

      if (item.state == 4) {
        ElMessage.error("\u5DF2\u8FC7\u671F");
        return false;
      }

      router.push({
        path: "/personal/AnnualDetail",
        query: {
          recordId: item.recordId,
          state: item.state,
          userId: item.userId,
          admin: "true",
          title: route.query.title,
          history: history,
          start: item.startTime,
          end: item.endTime
        }
      });
    };

    return {
      Data: Data,
      history: history,
      // name,
      changPage: changPage,
      itemClick: itemClick,
      getDetail: getDetail
    };
  }
});